// store.ts
import { InjectionKey } from "vue";
import { createStore, useStore as baseUseStore, Store } from "vuex";

export interface State {
  count: number;
  advertising: any;
}

export const key: InjectionKey<Store<State>> = Symbol("store");

export const store = createStore<State>({
  state: {
    count: 0,
    advertising: {}
  }
});

// define your own `useStore` composition function
export function useStore() {
  return baseUseStore(key);
}
